(() => {
  if (customElements.get('bc-builder-market')) return;
  class BuilderMarket extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select');
      this.grid = this.querySelector('.bc-builders__products');
      this.products = [...this.grid.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.section = this.closest('.bc-builders');
      this.video = this.section.querySelector('video');
      this.animations = [];
      this.manual = false;
      this.visible = false;
      this.change = () => { this.manual = true; this.stop(); this.sort(true); };
      this.pause = () => { this.engaged = true; this.stop(); };
      this.resume = () => { this.engaged = false; this.schedule(); };
      this.leaveFocus = event => { if (!this.contains(event.relatedTarget)) this.resume(); };
      this.onVisibility = () => this.sync();
      this.select.addEventListener('change', this.change);
      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.leaveFocus);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.section.toggleAttribute('data-in-view', this.visible);
        this.sync();
      }, { threshold: 0.1 });
      this.observer.observe(this.section);
      this.sort(false);
    }
    sort(announce) {
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      const previous = new Map(this.products.map(product => [product, product.getBoundingClientRect()]));
      const market = this.select.value;
      this.products.sort((a, b) => Number(a.dataset[`rank${market[0].toUpperCase()}${market.slice(1)}`]) - Number(b.dataset[`rank${market[0].toUpperCase()}${market.slice(1)}`]));
      this.products.forEach((product, index) => {
        product.querySelector('[data-rank]').textContent = index + 1;
        this.grid.append(product);
      });
      if (!this.motion.matches && announce) {
        this.products.forEach(product => {
          const before = previous.get(product);
          const after = product.getBoundingClientRect();
          const x = before.left - after.left, y = before.top - after.top;
          if (x || y) this.animations.push(product.animate([
            { transform: `translate(${x}px, ${y}px)`, opacity: 0.65 },
            { transform: 'translate(0, 0)', opacity: 1 }
          ], { duration: 650, easing: 'cubic-bezier(.22,1,.36,1)' }));
        });
      }
      if (announce && this.manual) this.querySelector('[aria-live]').textContent = `${this.dataset.reorderedLabel} ${this.select.selectedOptions[0].textContent.trim()}.`;
    }
    stop() { clearTimeout(this.timer); this.timer = null; }
    schedule() {
      this.stop();
      if (!this.visible || this.manual || this.engaged || document.hidden || this.motion.matches) return;
      this.timer = setTimeout(() => {
        this.select.selectedIndex = (this.select.selectedIndex + 1) % this.select.options.length;
        this.sort(true);
        this.schedule();
      }, 5500);
    }
    sync() {
      this.schedule();
      if (!this.video) return;
      if (this.visible && !document.hidden && !this.motion.matches) {
        const source = this.video.querySelector('[data-src]');
        if (source && !source.src) { source.src = source.dataset.src; this.video.load(); }
        this.video.play().catch(() => {});
      } else this.video.pause();
    }
    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.video?.pause();
      this.select?.removeEventListener('change', this.change);
      this.removeEventListener('pointerenter', this.pause);
      this.removeEventListener('pointerleave', this.resume);
      this.removeEventListener('focusin', this.pause);
      this.removeEventListener('focusout', this.leaveFocus);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener('change', this.onVisibility);
      this.ready = false;
    }
  }
  customElements.define('bc-builder-market', BuilderMarket);
})();
